import 'jquery';
import renameElement from '../util/renameElement';
import { addEventListeners } from '../util/events';

export default {
  elements: [],
  data: {
    forms: {},
  },
  init() {
    const _ = this;

    $(document).on('gform_page_loaded', function(event, form_id, current_page) {
      if (!_.data.forms[form_id]) {
        _.data.forms[form_id] = null;
      }
      let refresh = _.data.forms[form_id] !== current_page;
      refresh = true;
      if (refresh) {
        _.data.forms[form_id] = current_page;
        _.initElements();
      }
    });

    this.initElements();
  },
  initElements() {
    this.queryElements();

    this.prepareForms();
    this.prepareFields();
    this.prepareInputs();
    this.prepareButtons();
    this.prepareDependencies();

    this.initTooltips();
  },
  queryElements() {
    this.elements.forms = document.querySelectorAll('.gform_wrapper form, form[id^="gform_"]');
  },
  prepareForms() {
    this.elements.forms.forEach(form => {
      form.classList.add('is-loading');
      form.querySelectorAll('.gf_step_clear').forEach(element => element.remove());
      Array.from(form.querySelectorAll('.gfield[class*="col-"], .gfield.col')).some(column => {
        return column.parentNode.classList.contains('row') || column.parentNode.classList.add('row');
      });
      form.querySelectorAll('.row > :not([class*="col-"])').forEach(element => element.classList.add('col-12'));
    });
  },
  initTooltips() {
    $.fn.tooltip && $('[data-toggle="tooltip"]').tooltip();
  },
  prepareFields() {
    this.elements.forms.forEach(form => {
      form.querySelectorAll('ul.gform_fields').forEach(element => renameElement(element, 'div'));
      form.querySelectorAll('li[class*="gchoice_"]').forEach(element => renameElement(element, 'div'));
      form
        .querySelectorAll('.gfield.form-group > .ginput_container:not(.form-group)')
        .forEach(element => element.classList.add('form-group'));
      form.querySelectorAll('.gsection[class*="col-"]').forEach(element => element.classList.remove('gsection'));

      form.querySelectorAll('.gf_clear').forEach(element => element.remove());
      form
        .querySelectorAll('.address_zip + .address_city, .address_city + .address_zip')
        .forEach(element => element.classList.add('ml-3'));
    });
  },
  prepareInputs() {
    this.elements.forms.forEach(form => {
      form.querySelectorAll('.ginput_container_number > input[type="text"]').forEach(input => {
        input.setAttribute('type', 'number');
      });

      form.querySelectorAll('input[type="number"]').forEach(element => element.classList.add('form-control'));

      form.querySelectorAll('input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not(.form-control)').forEach(input => {
        input.classList.add('form-control');
      });

      form.querySelectorAll('[type="checkbox"],[type="checkbox"]').forEach(input => {
        input.classList.add('form-check-input');
        input.parentNode.classList.add('form-check');
        input.nextElementSibling.classList.add('form-check-label');
      });

      form.querySelectorAll('.textarea:not(.form-control)').forEach(input => {
        input.classList.add('form-control');
        input.classList.remove('textarea');
      });

      form.querySelectorAll('select').forEach(input => {
        input.classList.add('custom-select');
        input.classList.remove('textarea');
      });

      form.querySelectorAll('.gfield[class*=in-steps]').forEach(element => {
        const steps = element.className.match(/\bin-steps-(\d+)\b/);
        if (steps) {
          element.querySelectorAll('input[type="number"]').forEach(input => input.setAttribute('step', steps[1]));
        }
      });

      const setToNextStep = element => {
        let event;
        if ('object' === typeof element && element.originalTarget) {
          event = element;
          element = event.originalTarget;
        }
        if (!element.value) {
          return;
        }
        return (element.value = toNextStep({
          value: element.value,
          step: element.getAttribute('step') || 1,
          min: element.getAttribute('min') || null,
          max: element.getAttribute('max') || null,
        }));
      };

      const toNextStep = ({ value = 0, step = 1, min = null, max = null }) => {
        let nextStep = Math.ceil(value / step) * step;
        if (min) {
          nextStep = Math.max(min, nextStep);
        }
        if (max) {
          nextStep = Math.min(max, nextStep);
        }
        return nextStep;
      };

      form
        .querySelectorAll('input[type="number"][step]')
        .forEach(element => element.addEventListener('change', setToNextStep));

      form.querySelectorAll('[class*=move-after-]').forEach(container => {
        const match = /\bmove-(after|before)-(\d+)-([\w-]+)\b/;
        const [className, position, inputId, targetValue] = container.className.match(match);
        const targetInput = form.querySelector(`[name^="input_${inputId}"][value="${targetValue}"]`);
        if (targetInput) {
          if ('before' === position) {
            targetInput.parentNode.prependChild(container);
          } else {
            targetInput.parentNode.appendChild(container);
          }
          container.classList.add('form-sub-group');
          container.classList.remove(className);
        }
      });

      // Simulate checkbox style on radio inputs
      form.querySelectorAll('input[type="radio"], .custom-control-label').forEach(element => {
        let input;
        if ('label' === element.tagName.toLowerCase()) {
          if (element.getAttribute('for')) {
            input = document.getElementById(element.getAttribute('for'));
          }
          if (!input || !input.matches('[type="radio"]')) {
            input = element.parentNode.querySelector('[type="radio"]');
          }
        } else {
          input = element;
        }
        if (!input || input.tagName.toLowerCase() !== 'input') {
          return;
        }
        input.classList.add('input-radio-check');
        element.addEventListener('mousedown', () => {
          element.onclick =
            input.checked === true
              ? () => {
                  input.checked = false;
                  if (input.onclick) {
                    input.onclick.call();
                  }
                  return false;
                }
              : null;
        });
      });
    });
  },
  prepareButtons() {
    this.elements.forms.forEach(form => {
      form
        .querySelectorAll('.gf_step:last-child, .gf_step_last')
        .forEach(step => step.classList.add('btn', 'btn-primary'));
      form.querySelectorAll('.button').forEach(step => {
        step.classList.add('btn');
        step.classList.remove('button');
      });
      form.querySelectorAll('.gform_last_page_button').forEach(button => (button.value = 'Zurück zur letzten Seite'));
    });
  },
  prepareDependencies() {
    const _ = this;
    this.elements.forms.forEach(form => {
      form.querySelectorAll('[class*="depends-on-"]').forEach(element => {
        const dependInputId = element.className.match(/depends-on-(\d+)/)[1] || false;
        const formId = form.id.replace(/gform_/, '');
        if (!dependInputId) {
          return;
        }
        const dependInput = document.querySelector(`#input_${formId}_${dependInputId}`);
        if (!dependInput) {
          return;
        }
        element.classList.add('has-dependency');
        element.dependencyContainer = element.querySelector('.ginput_container') || element;
        element.dependencyNodes = Array.from(element.dependencyContainer.children);
        element.dependencyNodes.forEach(item => item.classList.add('dep-node'));
        addEventListeners(dependInput, 'click keypress', event => _.filterDependencies(event, element));
        _.filterDependencies(dependInput, element);
      });
    });
  },
  filterDependencies(input, element) {
    input = 'object' === typeof input && input.originalTarget ? input.originalTarget : input;
    const value = 'select' === input.tagName.toLowerCase() ? input.selectedOptions[0].value : input.value;
    const active = element.dependencyNodes.filter(item => item.classList.contains(value));
    element.dependencyNodes.forEach(item => item.classList.remove('filtered'));
    active.forEach(item => item.classList.add('filtered'));
    if (element.closest) {
      const fieldRow = element.closest('.gfield');
      fieldRow.style.display = 0 < active.length ? 'block' : 'none';
    }
  },
  finalize() {
    this.elements.forms.forEach(form => form.classList.remove('is-loading'));
  },
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/routes/hasForm.js